import axios from "axios";
import OrderFormStep from "../common/OrderFormStep";
import Config from "../common/Config";
import FieldState from "../common/FieldState";
import LoadFailureResult from "../common/LoadFailureResult";
import InputTextField from "../components/textField/InputTextField";
import PhoneNumber from "../components/phoneNumber/PhoneNumber";
import MuiRadio from "../components/radio/MuiRadio";
import FormTitle from "../components/formTitle/FormTitle";
import "./forms.scss";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";

export default class ClinicInfo extends OrderFormStep {
  constructor(props) {
    super(props);

    this.state = {
      accountNumber: localStorage.getItem("accountNumber"),
      states: [],
      contactMethods: [],
      shippingCarriers: [],
      shippingMethods: [],
      isSubmit: false,
      formState: {
        accountNumber: new FieldState(true),
        clinicName: new FieldState(true),
        prosthetistName: new FieldState(true),
        email: new FieldState(true),
        poNumber: new FieldState(false),
        shippingAddress1: new FieldState(false),
        shippingAddress2: new FieldState(false),
        city: new FieldState(false),
        stateId: new FieldState(false),
        stateName: new FieldState(false),
        zip: new FieldState(false),
        phone: new FieldState(true),
        contactMethodId: new FieldState(true),
        contactMethodName: new FieldState(false),
        shippingCarrierId: new FieldState(false),
        shippingCarrierName: new FieldState(false),
        shippingMethodId: new FieldState(false),
        shippingMethodName: new FieldState(false),
      },
    };

    this.onPhoneChange = this.onPhoneChange.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    // await axios.get(Config.baseApiUrl + "states").then(
    //   (response) => {
    //     this.setState({ states: response.data });
    //   },
    //   (error) => {
    //     // this.props.handleError(new LoadFailureResult());
    //   }
    // );

    await axios.get(Config.baseApiUrl + "contactMethods").then(
      (response) => {
        this.setState({ contactMethods: response.data });
      },
      (error) => {
        this.props.handleError(new LoadFailureResult());
      }
    );

    await axios.get(Config.baseApiUrl + "shippingCarriers").then(
      (response) => {
        this.setState({ shippingCarriers: response.data });
      },
      (error) => {
        this.props.handleError(new LoadFailureResult());
      }
    );

    // await axios.get(Config.baseApiUrl + "contactMethodId").then(
    //   (response) => {
    //     this.setState({ contactMethodId: response.data });
    //   },
    //   (error) => {
    //     // this.props.handleError(new LoadFailureResult());
    //   }
    // );

    await axios.get(Config.baseApiUrl + "shippingMethods").then(
      (response) => {
        this.setState({ shippingMethods: response.data });
      },
      (error) => {
        this.props.handleError(new LoadFailureResult());
      }
    );

    let config = {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
      },
    };

    await axios
      .get(Config.baseApiUrl + "clinicInfos/" + this.props.formTypeId, config)
      .then(
        (response) => {
          for (let key in response.data) {
            let fieldState = this.state.formState[key];
            if (fieldState) { // only set initialized fieldstates
              fieldState.value = response.data[key];
            }
          }
          // force UI render
          this.setState({ formState: this.state.formState });
        },
        (_) => {
          // this.props.handleError(new LoadFailureResult());
        }
      );
    this.setState({ isLoaded: true });
  }

  saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let data = {};
    for (let key in this.state.formState) {
      let fieldState = this.state.formState[key];
      data[key] = fieldState.value;
    }
    // return axios.post(
    //   Config.baseApiUrl + "clinicInfos/" + this.props.formTypeId,
    //   data,
    //   config
    // );

    if (this.validateData().isValid) {
      return axios.post(
        Config.baseApiUrl + "clinicInfos/" + this.props.formTypeId,
        data,
        config
      );
    } else {
      console.log(this.state.formState);
      this.setState({
        isSubmit: true,
      });
      CreateNotification(this.validateData().errorMessage, "error");

      return null;
    }
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  onPhoneChange(value) {
    this.setState({ number: value });
    if (value === undefined) {
      this.state.formState.phone.value = "";
    } else {
      this.state.formState.phone.value = value;
    }
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    return (
      <>
        <div className="checkFormWrapper">
          <FormTitle
            title="Customer Information"
            description="For your convenience, all WillowWood custom product order forms are listed below. "
          />

          <form className="checkform">
            <div className="fieldWrapper filedWidth">
              <InputTextField
                label="Clinician Name"
                variant="outlined"
                placeholder="Clinician"
                type="text"
                required={this.state.formState["prosthetistName"].isRequired}
                value={this.state.formState.prosthetistName.value}
                error={
                  this.handleError("prosthetistName") && this.state.isSubmit
                }
                onChange={(e) => this.onInputChange(e, "prosthetistName")}
              />

              <InputTextField
                label="Clinic Name"
                variant="outlined"
                placeholder="Clinic"
                required={this.state.formState["clinicName"].isRequired}
                type="text"
                value={this.state.formState.clinicName.value}
                error={this.handleError("clinicName") && this.state.isSubmit}
                onChange={(e) => this.onInputChange(e, "clinicName")}
              />

              <InputTextField
                label="Email Address"
                variant="outlined"
                placeholder="example@gmail.com"
                type="mail"
                required={this.state.formState["email"].isRequired}
                value={this.state.formState.email.value}
                error={this.handleError("email") && this.state.isSubmit}
                onChange={(e) => this.onInputChange(e, "email")}
              />

              <PhoneNumber
                counter={this.number}
                placeholder="Phone Number"
                country={"us"}
                value={this.state.formState.phone.value}
                onChange={(e) => {
                  this.onPhoneChange(e);
                }}
              />

              <InputTextField
                label="Bill to Account"
                variant="outlined"
                placeholder="Account"
                type="text"
                width="384px"
                required={this.state.formState["accountNumber"].isRequired}
                error={this.handleError("accountNumber") && this.state.isSubmit}
                value={this.state.formState.accountNumber.value}
                onChange={(e) => this.onInputChange(e, "accountNumber")}
                disabled={true}
              />
            </div>
            <MuiRadio
              options={this.state.contactMethods}
              checked
              required={this.state.formState["contactMethodId"].isRequired}
              error={this.handleError("contactMethodId") && this.state.isSubmit}
              defaultValue={this.state.formState.contactMethodId.value}
              label="Preferred Contact Method"
              onChange={(e) => {
                this.onRadioChange(e, "contactMethodId");
              }}
            />
          </form>
        </div>

        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => {
                this.props.handleBack(this.props.currentIndex - 1);
                if (this.props.setIsBack) this.props.setIsBack(true);
              }}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                try {
                  this.setState({ isLoading: true });
                  const res = await this.saveData();
                  if (res.status === 204) {
                    this.props.handleNext(this.props.currentIndex);
                    this.setState({ isLoading: false });
                    CreateNotification("Submitted", "success");
                  }
                } catch (err) {
                  this.setState({ isLoading: false });
                }
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        {/* <div>
          <h5 className="centeredText">Clinic Information</h5>
          <Form className="centered">
            <Form.Group controlId="accountNumber">
              <Form.Label>Bill to Account Number</Form.Label>
              <Form.Control value={this.state.accountNumber} disabled={true} />
            </Form.Group>
            <Form.Group controlId="clinicName">
              <Form.Label>Clinic</Form.Label>
              {this.makeFormControl()}
            </Form.Group>
            <Form.Group controlId="prosthetistName">
              <Form.Label>Prosthetist Name</Form.Label>
              {this.makeFormControl()}
            </Form.Group>
            <Form.Group controlId="email">
              <Form.Label>Email Address</Form.Label>
              {this.makeFormControl()}
            </Form.Group>
            <Form.Group controlId="poNumber">
              <Form.Label>PO Number</Form.Label>
              {this.makeFormControl()}
            </Form.Group>
            <Form.Group controlId="shippingAddress1">
              <Form.Label>Shipping Address Line 1</Form.Label>
              {this.makeFormControl()}
            </Form.Group>
            <Form.Group controlId="shippingAddress2">
              <Form.Label>Shipping Address Line 2</Form.Label>
              {this.makeFormControl()}
            </Form.Group>
            <Form.Group controlId="city">
              <Form.Label>City</Form.Label>
              {this.makeFormControl()}
            </Form.Group>
            <Form.Group controlId="stateId">
              <Form.Label>State</Form.Label>
              {this.makeFormControl({
                as: "select",
                options: (
                  <>
                    <option key="" value=""></option>
                    {this.state.states.map((s) => {
                      return (
                        <option key={s.id} value={s.id}>
                          {s.stateName}
                        </option>
                      );
                    })}
                  </>
                ),
              })}
            </Form.Group>
            <Form.Group controlId="zip">
              <Form.Label>Zip Code</Form.Label>
              {this.makeFormControl()}
            </Form.Group>
            <Form.Group>
              <Form.Label>Phone</Form.Label>
              <PhoneInput
                id="phone"
                className="form-control"
                country="US"
                value={this.state.formState.phone.value}
                onChange={this.onPhoneChange}
                ref={(input) => {
                  if (input === null) return;
                  this.applyRequiredClass(input);
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Preferred Contact Method</Form.Label>
              {this.makeRadioButtonList({
                id: "contactMethodId",
                data: this.state.contactMethods,
                valueField: "id",
                textField: "methodName",
              })}
            </Form.Group>
            <Form.Group>
              <Form.Label>Carrier</Form.Label>
              {this.makeRadioButtonList({
                id: "shippingCarrierId",
                data: this.state.shippingCarriers,
                valueField: "id",
                textField: "carrierName",
              })}
            </Form.Group>
            <Form.Group>
              <Form.Label>Shipping Method</Form.Label>
              {this.makeRadioButtonList({
                id: "shippingMethodId",
                data: this.state.shippingMethods,
                valueField: "id",
                textField: "methodName",
              })}
            </Form.Group>
          </Form>
        </div> */}
      </>
    );
  }
}
